import { Row, Col, Card, Progress, Typography, Button } from 'antd';
import { AnimatePresence, motion } from "motion/react";
import Avisos from './Avisos/Avisos';

import dayjs from 'dayjs';

const CardBienvenida = ({ alumno, progress, onHiddenCard }) => {
    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 30 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
            >
                <TextoBienvenida alumno={alumno} />
                <EstatusCv alumno={alumno} progress={progress} onHiddenCard={onHiddenCard} />
                <Avisos />
            </motion.div>
        </AnimatePresence>
    );
};

function TextoBienvenida({ alumno }) {
    return (
        <Row justify="center" align="middle">
            <Col span={24} align="center">
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
                    <Typography.Title level={3}>👋🏻 ¡ HOLA, {alumno?.nombre_completo} !</Typography.Title>
                </motion.div>
            </Col>
            <Col span={24} align="center">
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                    <Typography.Text style={{ fontSize: '16px', color: '#555' }}>
                        Este es tu espacio como egresado del CONALEP Estado de México.
                    </Typography.Text>
                </motion.div>
            </Col>
        </Row>
    );
}
function EstatusCv({ alumno, progress, onHiddenCard }) {
    return (
        <Row justify="center" style={{ marginTop: '50px' }}>
            <Col sm={24} md={12} >
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.4 }}>
                    <Card
                        style={{
                            borderRadius: '8px',
                            padding: '20px',
                            backgroundColor: '#ffffff',
                            textAlign: 'center',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                        }}
                        hoverable
                    >
                        <Typography.Title level={4}>Estado de tu hoja de vida</Typography.Title>
                        <Progress percent={progress} strokeColor="#9C1B29" style={{ marginBottom: '15px' }} />
                        <Row justify="space-between" align="middle">
                            <Col xs={24} sm={9}>

                                <Typography.Text style={{ color: '#999', fontSize: '14px' }}>
                                    Última actualización: {alumno?.last_login ? dayjs(alumno?.last_login).format('DD/MM/YYYY') : dayjs().format('DD/MM/YYYY')}
                                </Typography.Text>

                            </Col>
                            <Col sm={24} md={12} style={{ textAlign: 'right' }}>
                                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3, delay: 0.6 }}>
                                    <Button
                                        type="primary"
                                        size="small"
                                        onClick={onHiddenCard}
                                        style={{
                                            backgroundColor: '#9C1B29',
                                            borderColor: '#9C1B29',
                                        }}
                                    >
                                        {progress === 100 ? 'Continuar' : 'Actualizar'}
                                    </Button>
                                </motion.div>
                            </Col>
                        </Row>
                    </Card>
                </motion.div>
            </Col>
        </Row>
    )
}

export default CardBienvenida;
